import React from 'react';

import CountOfTotal from '../../../../../components/CountOfTotal';
import SelectForm from '../../../../../components/form/SelectForm';
import TextAreaForm from '../../../../../components/form/TextAreaForm';
import Modal from '../../../../../components/Modal';
import InfoForm from '../../../../../components/outline/InfoForm';
import useConfirmPropertyMutate from '../../../../../hooks/queries/product/useConfirmPropertyMutate';
import { formRequiredRules } from '../../../../../lib/formRules';
import { setTrim } from '../../../../../lib/common';
import {
  MAXIMUM_NUMBER_OF_PRODUCT_TAG_REJECT_REASON_TEXT,
  PRODUCT_PROPERTY_REJECT_TYPE_SELECT_LIST,
} from '../../../../../constants/service/app/productConstants';
import { REQUIRED_MSG } from '../../../../../constants/service/common/formRulesConstants';
import './RejectRegistrationProductProperty.scss';

const RejectRegistrationProductProperty = (props) => {
  const { form, isOpen, closeModal, type, reason, data, setData } = props;
  const { rejectProperty } = useConfirmPropertyMutate(data.setType);

  /**
   * 상품 속성 승인 거절하기
   */
  const onSubmit = () => {
    const { productId, productPropertyType } = data;
    form.validateFieldsAndScroll({ scroll: { offsetBottom: 100 } }, (err) => {
      if (err) return;

      rejectProperty.mutate({
        productId,
        productPropertyType,
        type,
        reason: setTrim(reason),
      });

      /**
       *  모달 닫기
       */
      closeModal();
    });
  };

  return (
    <Modal
      title="상품 속성 승인 거절"
      isOpen={isOpen}
      width={600}
      height={300}
      isFooter={true}
      okText="상품 속성 승인 거절"
      overflow="hidden"
      onOk={() => onSubmit()}
      onClose={() => closeModal()}
    >
      <InfoForm className="reject-registration-product-property-modal">
        <SelectForm
          form={form}
          label="상품 속성 승인 거절 타입"
          isTable
          rules={[formRequiredRules(true, REQUIRED_MSG, false)]}
          initialValue={type}
          onChange={(value) => setData({ name: 'type', value })}
          list={PRODUCT_PROPERTY_REJECT_TYPE_SELECT_LIST}
          name="type"
        />

        <TextAreaForm
          form={form}
          label={
            <span>
              상품 속성 승인 거절 사유
              <CountOfTotal content={reason} maxCnt={MAXIMUM_NUMBER_OF_PRODUCT_TAG_REJECT_REASON_TEXT} />
            </span>
          }
          rules={[formRequiredRules(true, REQUIRED_MSG)]}
          initialValue={reason}
          maxLength={MAXIMUM_NUMBER_OF_PRODUCT_TAG_REJECT_REASON_TEXT}
          onChange={(value) => setData({ name: 'reason', value })}
          name="reason"
          rows={6}
        />
      </InfoForm>
    </Modal>
  );
};

export default RejectRegistrationProductProperty;
